export default "__VITE_ASSET__Cey2H1Fq__"